import React, { useEffect, useState, useRef } from 'react';
import { showToastMessage, userToken, executeLaravelAPI, executeLaravelFrontAPI, buttonLoadingClass, uploadAssets } from '../../Utils';
import { Form } from 'react-bootstrap';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { Icon } from '@iconify/react';
import SubmitButton from '../../shared/SubmitButton';
import ConfirmationModal from '../Confirmation';

const ProjectEditPriceConfiguration = ({selectedProjectId }) => {
    const buttonClass=useRef('theme-btn');
    const [buttonClassLoader, setButtonClass] = useState(buttonClass.current);
    const [projectPriceConfigData, setEditedItem] = useState({}); 
    const [towersData, setTowersData] = useState([]);
    const [configurationsData, setConfigurationsData] = useState({});
    const [selectedTowerId, setSelectedTowerId] = useState('');
    const [selectedFetchedFromValue, setSelectedFetchedFromValue] = useState('');
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [imageUploadConfigIds, setImageUploadConfigIds] = useState([]);

    const [configurationAsset, setConfigurationsAssetData] = useState('');

    const inputReraRefs = useRef([]);
    //const input99acreRefs = useRef([]);
    //const inputDwelloRefs = useRef([]);
    const inputCustomRefs = useRef([]);
    const inputBalconyAreaRefs = useRef([]);
    const inputDryAreaRefs = useRef([]);
    const inputConfigNameRefs = useRef([]);
    const inputCarpetNameRefs = useRef([]);
    const inputActiveRefs = useRef([]);
    const inputOffersRefs = useRef([]);
    const inputQuotedPriceRefs = useRef([]);
    

    const sortConfigurations = (configs = []) => {
        // Sort by active status: active rows first, deactivated rows at bottom
        return [...configs].sort((a, b) => {
            // Active rows (true/1) come first, inactive rows (false/0) come last
            const aActive = Number(a.is_active) || 0;
            const bActive = Number(b.is_active) || 0;
            return bActive - aActive; // Descending order (active first, then inactive)
        });
    };

    useEffect(() => {
        //getConfig();
        const getProjects = async () => {
            try {
                const result = await executeLaravelAPI(`project/view/${selectedProjectId}`, '', 'GET', userToken);
                const dataProjectDetails = result.data;

                const configurationsAssetData = await executeLaravelFrontAPI(`projectconfigurationassets/${selectedProjectId}`, '', 'GET', '');
                setConfigurationsAssetData(configurationsAssetData.data);
                setEditedItem(dataProjectDetails); // Set the projectPriceConfigData state
                setSelectedFetchedFromValue(dataProjectDetails.price_fetched_from);
                const towersdata = dataProjectDetails.towers;
                const towerId = towersdata.length > 0 ? towersdata[0].id : '';
                const configurationdata = towersdata.find(tower => tower.id === towerId)
                inputReraRefs.current = Array(configurationdata.length).fill(null).map(() => React.createRef());
                //input99acreRefs.current = Array(configurationdata.length).fill(null).map(() => React.createRef());
                //inputDwelloRefs.current = Array(configurationdata.length).fill(null).map(() => React.createRef());
                inputCustomRefs.current = Array(configurationdata.length).fill(null).map(() => React.createRef());
                inputBalconyAreaRefs.current = Array(configurationdata.length).fill(null).map(() => React.createRef());
                inputDryAreaRefs.current = Array(configurationdata.length).fill(null).map(() => React.createRef());
                inputConfigNameRefs.current = Array(configurationdata.length).fill(null).map(() => React.createRef());
                inputCarpetNameRefs.current = Array(configurationdata.length).fill(null).map(() => React.createRef());
                inputActiveRefs.current = Array(configurationdata.length).fill(true).map(() => React.createRef());
                inputOffersRefs.current = Array(configurationdata.length).fill(true).map(() => React.createRef());
                inputQuotedPriceRefs.current = Array(configurationdata.length).fill(true).map(() => React.createRef());
                
                setTowersData(towersdata);
                setConfigurationsData(sortConfigurations(configurationdata.configurations));
                setSelectedTowerId(towerId);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        if (selectedProjectId) {
            getProjects();
        }
    }, [selectedProjectId]);

    //console.log(fetchedFromPortal);

    const [tableData, setTableData] = useState([
        { id: 1, config: '', value1: '', value2: '', value3: '', value4: '', value5: '' },
    ]);

    const handleFetchedFromPriceSelectChange = (e) => {
        setSelectedFetchedFromValue(e.target.value);
    };

    const handleTowerChange = (e) => {
        const towerId = parseInt(e.target.value);
        const towersdata = projectPriceConfigData.towers;
        const configurationdata = towersdata.find(tower => tower.id === towerId)

        inputReraRefs.current = Array(configurationdata.length).fill(null).map(() => React.createRef());
        inputCustomRefs.current = Array(configurationdata.length).fill(null).map(() => React.createRef());
        inputBalconyAreaRefs.current = Array(configurationdata.length).fill(null).map(() => React.createRef());
        inputDryAreaRefs.current = Array(configurationdata.length).fill(null).map(() => React.createRef());
        inputConfigNameRefs.current = Array(configurationdata.length).fill(null).map(() => React.createRef());
        inputCarpetNameRefs.current = Array(configurationdata.length).fill(null).map(() => React.createRef());
        inputOffersRefs.current = Array(configurationdata.length).fill(null).map(() => React.createRef());
        inputActiveRefs.current = Array(configurationdata.length).fill(null).map(() => React.createRef());
        inputQuotedPriceRefs.current = Array(configurationdata.length).fill(null).map(() => React.createRef());

        setTowersData(towersdata);
        setConfigurationsData(sortConfigurations(configurationdata.configurations));
        setSelectedTowerId(towerId);
       // console.log(projectPriceConfigData);
        setEditedItem(projectPriceConfigData);
        //console.log(configurationdata);

    };

    const handleFileChange = (e, index, id) => {
        const files = Array.from(e.target.files);
        setSelectedFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles[index] = files[0];
            return newFiles;
        });
        setImageUploadConfigIds(prevIds => [...prevIds, id]);
    };

    // const [inputDwelloPriceValue, setDwelloConfPriceInputValue] = useState([configurationsData.length].fill(''));
    // const [input99acrePriceValue, set99acreConfPriceInputValue] = useState([configurationsData.length].fill(''));
    // const [inputReraPriceValue, setReraConfPriceInputValue] = useState([configurationsData.length].fill(''));
    // const [inputCustomPriceValue, setCustomConfPriceInputValue] = useState([configurationsData.length].fill(''));

    // const [inputBalconyArea, setBalconyArea] = useState([configurationsData.length].fill(''));
    // const [inputDryArea, setDryArea] = useState([configurationsData.length].fill(''));
    // const [inputConfigName, setConfigName] = useState([configurationsData.length].fill(''));
    // const [inputCarpetName, setCarpetName] = useState([configurationsData.length].fill(''));
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [tempConfigDetails, setTempConfigDetails] = useState({ index: null, configId: null });

    const handleDeleteConfigRow = (index, configId) => {
        setTempConfigDetails({ index, configId });
        setShowConfirmModal(true);
    };

    const handleConfirmDeleteConfig = async () => {
        const { index, configId } = tempConfigDetails;
        setShowConfirmModal(false);
        try {
            if (configId && configId !== '') {
                const response = await executeLaravelAPI(`configuration/delete/${configId}`, {}, 'DELETE', userToken);
                if (response && response.status === 200) {
                    const updatedResult = await executeLaravelAPI(`project/view/${selectedProjectId}`, '', 'GET', userToken);
                    const dataProjectDetails = updatedResult.data;
                    const aprArray = dataProjectDetails.configurations.map(item => `${item.bedrooms}=${item.final_price}=${item.carpet}`);
                    await executeLaravelAPI(`setconfigurationapr/${selectedProjectId}`, { aprArray }, 'POST', userToken);
                    showToastMessage('Configuration deleted successfully', 'top-right', 'success');
                } else {
                    showToastMessage('Failed to delete configuration', 'top-right', 'error');
                }
            }
            setConfigurationsData((prev) => prev.filter((_, idx) => idx !== index));
        } catch (error) {
            console.error('Error deleting configuration:', error);
            showToastMessage('Error deleting configuration', 'top-right', 'error');
        }
    };

    const handleCancelDeleteConfig = () => {
        setShowConfirmModal(false);
        setTempConfigDetails({ index: null, configId: null });
    };

    const addNewConfigRow = () => {
        const newConfigurations = [...configurationsData];
        // Generate a unique temporary id for new rows to avoid conflicts
        const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        newConfigurations.push({
            id: '',
            tempId: tempId, // Temporary unique identifier for React keys
            name: '',
            carpet: '',
            balcony_area: '',
            dry_area: '',
            rera_price: '',
            custom_price: '',
            is_active: true,
            offers: ''
        });
        setConfigurationsData(sortConfigurations(newConfigurations));
    };

    const updatePriceConfiguration = async (e) => {
        e.preventDefault();
        try {
            setButtonClass(`${buttonClass.current} ${buttonLoadingClass}`);
            
            const configsToProcess = configurationsData.map((config, index) => ({ config, index }))
                .filter(({ config }) => {
                    // Keep configs that have an ID or have required fields filled
                    if (config.id && config.id !== '') return true;
                    if (config.name && config.name.trim() !== '') return true;
                    return false; // Skip empty new configurations
                });

            const updatedConfigurations = configsToProcess.map(async ({ config, index: originalIndex }) => {
                try {
                     if(config.id === '' || !config.id){
                        // Create new configuration
                        const newConfig = await executeLaravelAPI(`configuration/create`, {
                            ...config,
                            tower_id: selectedTowerId || selectedProjectId, // Use selectedTowerId if available
                            project_id: selectedProjectId,
                            final_price: config.quoted_price || config.final_price || 0,
                            bedrooms: config.bedrooms || 0,
                            balcony_area: config.balcony_area || null,
                            dry_area: config.dry_area || null,
                            rera_price: config.rera_price || null,
                            custom_price: config.custom_price || null,
                            is_active: config.is_active !== undefined ? config.is_active : true,
                            offers: config.offers || '',
                            is_verified: true
                        }, 'POST', userToken);
                        return newConfig;
                    } else {
                        // Update existing configuration
                        await executeLaravelAPI(`configuration/edit/${config.id}`, {
                            ...config,
                        }, 'PUT', userToken);
                        return config;
                    }
                } catch (configError) {
                    console.error(`Error processing configuration at index ${originalIndex}:`, configError);
                    showToastMessage(`Error saving configuration ${originalIndex + 1}: ${configError.message || 'Unknown error'}`, 'top-right', 'error');
                    throw configError; // Re-throw to be caught by outer catch
                }
            });
            // Wait for all configurations to be saved
            if (updatedConfigurations.length > 0){
                await Promise.all(updatedConfigurations);
            }

            // Refetch updated configurations to get database IDs for new rows
            const updatedResult = await executeLaravelAPI(`project/view/${selectedProjectId}`, '', 'GET', userToken);
            const dataProjectDetails = updatedResult.data;
            const aprArray = dataProjectDetails.configurations.map(item => `${item.bedrooms}=${item.final_price}=${item.carpet}`);
            await executeLaravelAPI(`setconfigurationapr/${selectedProjectId}`, { aprArray }, 'POST', userToken);
            setEditedItem(dataProjectDetails);
            
            const towersdata = dataProjectDetails.towers || [];
            const configurationdata = towersdata.find(tower => tower.id === selectedTowerId);
            if (configurationdata && configurationdata.configurations) {
                setConfigurationsData(sortConfigurations(configurationdata.configurations));
            } else if (towersdata.length > 0 && towersdata[0].configurations) {
                // Fallback to first tower if selected tower not found
                setConfigurationsData(sortConfigurations(towersdata[0].configurations));
                setSelectedTowerId(towersdata[0].id);
            }

            const updatedConfigurationsAssetData = await executeLaravelFrontAPI(`projectconfigurationassets/${selectedProjectId}`, '', 'GET', '');
                setConfigurationsAssetData(updatedConfigurationsAssetData.data);

            // Clear selected files after successful save
            setSelectedFiles([]);
            setImageUploadConfigIds([]);

            showToastMessage('Configuration(s) Updated Successfully', 'top-right', 'success');
            setButtonClass(buttonClass.current);
            
        } catch (error) {
            console.error('Error updating configurations:', error);
            showToastMessage(`Error updating configurations: ${error.message || 'Please try again'}`, 'top-right', 'error');
            setButtonClass(buttonClass.current);
        }
        
    }

    function handleFieldChange(index, field, value) {
        setConfigurationsData(prev => {
            
            const newConfigurations = [...prev];
            if (field === 'quoted_price') {
                newConfigurations[index]['final_price'] = value;
            }
            newConfigurations[index] = { ...newConfigurations[index], [field]: value };
            return newConfigurations;
        });
    }


    return (
        <>
        <form onSubmit={updatePriceConfiguration} className='projectForm' encType="multipart/form-data">
            <table className="table table-resposive mt-0 p-0 mb-0">
                <thead></thead>
                <tbody>
                    <tr>
                        <td className='px-0 pb-2 mb-4'>
                            <Form.Group className="row">
                                <div className="col-sm-12">
                                    
                                    <FloatingLabel controlId="floatingInput" label="Select Price Fetched From">
                                        <select name="fetched_from_price" className="form-select" value={selectedFetchedFromValue} onChange={handleFetchedFromPriceSelectChange} >
                                            <option>--Select Price Fetched From--</option>
                                            <option value="rera" selected={selectedFetchedFromValue==='rera'}>Rera</option>
                                            <option value="custom" selected={selectedFetchedFromValue==='custom'}>Custom</option>
                                        </select>
                                    </FloatingLabel>
                                </div>
                            </Form.Group>
                        </td>
                    </tr>
                   
                    <tr>
                        <td>
                            <div className='row'>
                                <div className='col-12 px-0'>
                                <input type="hidden" id="configassets" value={imageUploadConfigIds || ''} redOnly />
                                    <table className='table table-resposive mt-0 p-0 mb-0 table-hover table-bordered configuration-table'>  
                                        <thead></thead>
                                        <tbody>
                                            <tr className='table-secondary'>
                                                <td>No</td>
                                                <td style={{'width':'130px'}}>BHK Type</td>
                                                <td>No.Bedrooms</td>
                                                <td>Carpet Area (sq.ft.)</td>
                                                <td>Quoted Price</td> 
                                                <td>
                                                    <button type='button' className='btn btn-outline-success rounded-circle add-config text-success' onClick={(e)=> addNewConfigRow()}>
                                                        <Icon icon="ic:sharp-add" style={{ fontSize: '24px' }} />
                                                    </button>
                                                </td>
                                            </tr>
                                            {/* {selectedTowerId && ( */}
                                                <>
                                               
                                                {Array.isArray(configurationsData) ? configurationsData.map((config, index) => (

                                                        <tr key={config.id || config.tempId || index}>

                                                            <td>{(index+1)}</td>
                                                            {/* <td>
                                                                <select className='form-select' disabled="disabled">
                                                                    <option key={config.id} value={config.name}>{config.name}</option>
                                                                </select>
                                                            </td> */}
                                                            <td> 
                                                                <input   
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={config.name}
                                                                    onChange={(e) => handleFieldChange(index, 'name', e.target.value)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={config.bedrooms}
                                                                    onChange={(e) => handleFieldChange(index, 'bedrooms', e.target.value)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                

                                                                type="text"
                                                                className="form-control"
                                                                value={config.carpet}
                                                                onChange={(e) => handleFieldChange(index, 'carpet', e.target.value)}
                                                                />
                                                            </td>
                                                            {/* <td>
                                                                <input
                                                                    

                                                                    type="text"
                                                                    className="form-control"
                                                                    value={config.balcony_area}
                                                                    onChange={(e) => handleFieldChange(index, 'balcony_area', e.target.value)}
                                                                />
                                                                 
                                                            </td> 
                                                            <td>
                                                                <input
                                                                   

                                                                    type="text"
                                                                    className="form-control"
                                                                    value={config.dry_area}
                                                                    onChange={(e) => handleFieldChange(index, 'dry_area', e.target.value)}
                                                                />
                                                            </td>*/}
                                                            {/* <td className={`${selectedFetchedFromValue==='dwello' ? 'active' : ''}`}>
                                                                <input
                                                                   
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={config.dwello_price}
                                                                    onChange={(e) => handleFieldChange(index, 'dwello_price', e.target.value)}
                                                                />
                                                            </td>
                                                            <td className={`${selectedFetchedFromValue==='99acre' ? 'active' : ''}`}>
                                                                <input
                                                                
                                                                type="text"
                                                                className="form-control"
                                                                value={config.acre99_price}
                                                                onChange={(e) => handleFieldChange(index, 'acre99_price', e.target.value)}
                                                                />
                                                            </td> */}
                                                            {/* <td className={`${selectedFetchedFromValue==='rera' ? 'active' : ''}`}>
                                                                <input
                                                               
                                                                type="text"
                                                                className="form-control"
                                                                value={config.rera_price}
                                                                onChange={(e) => handleFieldChange(index, 'rera_price', e.target.value)}
                                                                />
                                                            </td>
                                                            <td className={`${selectedFetchedFromValue==='custom' ? 'active' : ''}`}>
                                                                <input
                                                                
                                                                type="text"
                                                                className="form-control"
                                                                value={config.custom_price}
                                                                onChange={(e) => handleFieldChange(index, 'custom_price', e.target.value)}
                                                                />
                                                            </td> */}
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={config.quoted_price}
                                                                    onChange={(e) => handleFieldChange(index, 'quoted_price', e.target.value)}
                                                                />
                                                                <input
                                                                    type="hidden"
                                                                    name="final_price"
                                                                    value={config.final_price}
                                                                    onChange={(e) => handleFieldChange(index, 'final_price', e.target.value)}
                                                                />
                                                            </td>
                                                            <td className='text-center'>
                                                                <a
                                                                    href="#remove-config"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        handleDeleteConfigRow(index, config.id);
                                                                    }}
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    <Icon
                                                                        icon='ion:close-outline'
                                                                        style={{ fontSize: '30px', color: '#192951' }}
                                                                    />
                                                                </a>
                                                            </td>
                                                            {/* <td>
                                                                {configurationAsset && configurationAsset.map((asset) => {
                                                                if (asset.configuration_id === config.id) {
                                                                    return (
                                                                        <img key={asset.id} src={`${s3url}/project-assets${asset.url}`} alt="Configuration" width="100" />
                                                                    );
                                                                }
                                                                return null;
                                                            })}
                                                            <input type="file" className="form-control" onChange={(e) => handleFileChange(e, index, config.id)} />
                                                            </td> */}
                                                            {/* <td>
                                                            <SelectToSearch 
                                                                type={"offers"} 
                                                                defaultValues={config?.offers} 
                                                                name="offers" 
                                                                onChange={(selectedOptions) => handleSelectChange(selectedOptions)} 
                                                                typesection="configuration"
                                                            />
                                                            </td> */}
                                                        </tr>
                                                   )) : null}
                                                </>
                                            {/* )} */}
                                        </tbody>
                                        <tfoot></tfoot>
                                    </table>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>    
                <tfoot>
                    <tr>
                        <td>
                            <div className='text-end mt-3'>
                                <SubmitButton
                                    variant="success"
                                    type="submit"
                                    className={buttonClassLoader}
                                    label="Update Price Configurations"
                                />
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </form>
        <ConfirmationModal
            show={showConfirmModal}
            onConfirm={handleConfirmDeleteConfig}
            onCancel={handleCancelDeleteConfig}
            modelBody={"Are you sure you want to delete this configuration?"}
        />
        </>
    );                                             
}                                                 

export default ProjectEditPriceConfiguration;
